import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {postCouponRegistration} from '../../actions/coupons.actions';
import {preventDuplicatedSubmit} from '../../util/duplicatedSubmitPreventUtil';
import {Button, ButtonGroup, PageContainer, PageTitle} from '../Common/PageComponents';

import './products.scss';

const stateToProps = state => {
  return {
    pcbId: state.user.pcbId,
  };
};

class CouponRegistration extends Component {
  constructor(props, context) {
    super(props, context);
    this.submitCouponRegistrationRequest = preventDuplicatedSubmit(e => this._registerCoupon(e), 2000);
  }

  _registerCoupon(e) {
    e.preventDefault();
    if (!this._validateCouponCode([this.coupon1, this.coupon2, this.coupon3, this.coupon4])) {
      return;
    }

    let couponCode = (this.coupon1.value + this.coupon2.value + this.coupon3.value + this.coupon4.value).toLowerCase();
    this.props.dispatch(postCouponRegistration(this.props.pcbId, couponCode, this.props.history));
  }

  _validateCouponCode(couponCodeInputs) {
    for (let input of couponCodeInputs) {
      if (!input.value.match(/^[a-zA-Z0-9]{8}$/)) {
        alert('쿠폰 코드를 정확히 입력해주세요.');
        input.focus();
        return false;
      }
    }
    return true;
  }

  render() {
    return (
      <PageContainer>
        <PageTitle title="PC방 쿠폰 코드 등록" />
        <div style={{background: '#e7e7e7', padding: '30px', borderRadius: '6px'}}>
          <p style={{textAlign: 'center', marginTop: '30px', marginBottom: '20px'}}>
            PC방 프로모션 쿠폰 코드를 등록해주세요.
          </p>
          <div className="coupon_box">
            <span>
              <input
                type="text"
                maxLength={8}
                className="coupon_input"
                title="첫번째 쿠폰코드 번호"
                placeholder="8자리"
                ref={node => (this.coupon1 = node)}
              />
            </span>
            <span>
              <input
                type="text"
                maxLength={8}
                className="coupon_input"
                title="두번째 쿠폰코드 번호"
                placeholder="8자리"
                ref={node => (this.coupon2 = node)}
              />
            </span>
            <span>
              <input
                type="text"
                maxLength={8}
                className="coupon_input"
                title="세번째 쿠폰코드 번호"
                placeholder="8자리"
                ref={node => (this.coupon3 = node)}
              />
            </span>
            <span>
              <input
                type="text"
                maxLength={8}
                className="coupon_input"
                title="네번째 쿠폰코드 번호"
                placeholder="8자리"
                ref={node => (this.coupon4 = node)}
              />
            </span>
          </div>
        </div>
        <ButtonGroup>
          <Button onClick={e => this.submitCouponRegistrationRequest(e)}>등록</Button>
        </ButtonGroup>
      </PageContainer>
    );
  }
}

export default withRouter(connect(stateToProps)(CouponRegistration));
